var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDegreeHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8415 21.8437C43.1996 21.6858 43.5034 21.4263 43.7154 21.0973C43.9274 20.7684 44.0382 20.3845 44.0342 19.9932C44.0302 19.6019 43.9114 19.2204 43.6927 18.8959C43.4739 18.5714 43.1648 18.3182 42.8035 18.1677L25.6615 10.3597C25.1404 10.122 24.5743 9.99902 24.0015 9.99902C23.4288 9.99902 22.8627 10.122 22.3415 10.3597L5.20155 18.1597C4.84549 18.3157 4.54258 18.572 4.32988 18.8974C4.11718 19.2227 4.00391 19.603 4.00391 19.9917C4.00391 20.3805 4.11718 20.7607 4.32988 21.0861C4.54258 21.4115 4.84549 21.6678 5.20155 21.8237L22.3415 29.6397C22.8627 29.8774 23.4288 30.0005 24.0015 30.0005C24.5743 30.0005 25.1404 29.8774 25.6615 29.6397L42.8415 21.8437Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20V32",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25V32C12 33.5913 13.2643 35.1174 15.5147 36.2426C17.7652 37.3679 20.8174 38 24 38C27.1826 38 30.2348 37.3679 32.4853 36.2426C34.7357 35.1174 36 33.5913 36 32V25",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegreeHat);
export default __webpack_public_path__ + "static/media/degreeHat.e126a89d3c9455a3ef25dbbb51968fd4.svg";
export { ForwardRef as ReactComponent };